import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import {
  filterToQuery,
  inputText,
  matchSuggestion,
  OptionRenderer,
} from "../common/CustomSelectOption";

const customerDebtPaymentFilterList = (permissions) => {
  const defaultFilter = [
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      source="customer_id"
      reference="customers"
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        resettable
        variant="outlined"
        label="mine.label.customer"
        optionValue="id"
        optionText={<OptionRenderer />}
        inputText={inputText}
        matchSuggestion={matchSuggestion}
        filterToQuery={filterToQuery}
        sx={{ minWidth: "400px" }}
      />
    </ReferenceInput>,
    <TextInput
      alwaysOn
      source="tbp"
      label="TBP"
      resettable
      variant="outlined"
    />,
    <AutocompleteInput
      source="type"
      alwaysOn
      optionText="name"
      variant="outlined"
      label="mine.label.type"
      resettable
      choices={[
        { id: 1, name: "Transfer" },
        { id: 2, name: "Cash" },
        { id: 3, name: "Giro" },
      ]}
    />,
    <TextInput
      alwaysOn
      source="note"
      label="mine.label.note"
      resettable
      variant="outlined"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default customerDebtPaymentFilterList;
